export const getStripFilterOptionStaggerKey = (
  filterName: string,
  optionName: string
) => `${filterName}:${optionName}`;
